import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined
})

// getters
const getters = {}

// actions
const actions = {
    // get records
    async get({state, commit}, {filterData}) {
        commit('setLoading', true)

        state.filterData = filterData;

        let params = {};

        if(state.filterData){
            params = {...params, ...state.filterData};
        }

        const res = await this._vm.axios.get(this._vm.endpoints['module_exam_question_type'], {
            params: params
        })

        const {data} = res.data
        commit('updateTableData', data)

        setTimeout(() => {
            commit('setLoading', false)
        }, 250)
    },

    // refresh records
    refresh({state, dispatch}) {
        dispatch('get', {
            filterData: state.filterData
        })
    }
}

// mutations
const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
